import React from 'react'
import GoogleMapMarker from 'Common/GoogleMapMarker'
import moment from 'moment';
import { getColorForName } from 'Helpers/colorPalette';

export default ({
  timestamp,
  locationLatitude = null, 
  locationLongitude = null,
  publisherId,
  ...props
}) => {
  const { feedbackDetails: { reporterMobile , type },name } = props
  const isReporter = publisherId.includes(reporterMobile);
  const nameColor = getColorForName(name);
  return (
    <div className={ `${ isReporter ? 'repoter' : 'repoted' }` }>
         <GoogleMapMarker latitude={ locationLatitude } longitude={ locationLongitude } nameColor={ nameColor } name={ name } type= { type } >
           <span className='attachment-time'>{ moment(parseInt(timestamp)).format('h:mm A') } </span>
         </GoogleMapMarker>
    </div>
  )
}
